import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';

export interface EmployeeList {
  product: string;
  code : string;
  orders : number;
  stocks : number;
  incoming : number;
  WIP : number;
  unplanned : number;
  unit : string;
  leadtime : string;
 }
 
 const ELEMENT_DATA: EmployeeList[] = [
   {product: 'S/C EM4 DIA 10X25X70 MM C', code: 'SUZPRW90x360',orders : 78666,stocks : 0,
   incoming :58,WIP:4000,unplanned : 75489,unit : 'piece(s)',leadtime :'15'},
   {product: 'Brite EcoLite 175', code: '	132F0020',orders : 85586,stocks : 15,
   incoming :14,WIP:0,unplanned : 45488,unit : 'piece(s)',leadtime :'1'},
   {product: 'Compound Microscope', code: 'Hub 1325606',orders : 21535,stocks : 5,
   incoming :8,WIP:14,unplanned : 87544,unit : 'piece(s)',leadtime :'10'},
   {product: 'Hub 1325606', code: 'PTC-199',orders : 21535,stocks : 4,
   incoming :76,WIP:2,unplanned : 8754,unit : 'no.s',leadtime :'14'},
   {product: 'Bright Eco Light - D.Login', code: 'Tubelight',orders : 21535,stocks : 59,
   incoming : 6,WIP:53,unplanned : 8787,unit :  'no.s',leadtime :'11'},
   {product: 'Pubelight', code: '	D.Login',orders :51535,stocks : 68,
   incoming :0,WIP:4,unplanned : 15498,unit :  'no.s',leadtime :'19 '},
   {product: 'umang patel', code: 'SUZPRW90x360',orders : 21535,stocks : 845,
   incoming :75,WIP:7,unplanned : 15498,unit :  'no.s',leadtime :'18 '},
   {product: 'umang patel', code: 'SUZPRW90x360',orders : 21535,stocks : 5,
   incoming :12,WIP:6,unplanned :15498,unit : 'piece(s)',leadtime :'16 '},
   {product: 'umang patel', code: 'SUZPRW90x360',orders : 51535,stocks : 6,
   incoming :1,WIP:8,unplanned : 7844,unit : 'piece(s)',leadtime :'13 '},
   {product: 'umang patel', code: 'Brite EcoLite 175',orders : 21535,stocks : 7,
   incoming :4,WIP:7,unplanned : 548447,unit : 'piece(s)',leadtime :'8 '},
 ];


@Component({
  selector: 'app-production-planning',
  templateUrl: './production-planning.component.html',
  styleUrls: ['./production-planning.component.scss']
})
export class ProductionPlanningComponent implements OnInit {

 
  displayedColumns: string[] = ['product','code','orders','stocks','incoming','WIP','unplanned','unit','leadtime','edit','delete'];
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);

  @ViewChild('pprtable', { static: false }) pprtable!: ElementRef;
  
  @ViewChild(MatSort)
  sort!: MatSort;

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
  }

  refresh() {
    window.location.reload();
  }

 
  exportToExcel() {
  const ws: xlsx.WorkSheet =
    xlsx.utils.table_to_sheet(this.pprtable.nativeElement);
  const wb: xlsx.WorkBook = xlsx.utils.book_new();

  xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
  xlsx.writeFile(wb, 'ProductPlanningReport.xlsx');
}

backBtn() {
  this.router.navigate(['/Stock']);
}
}
